import React from 'react';
import TweenOne from 'rc-tween-one';
import { Menu, Image } from 'antd';
import {Link} from "react-router-dom";
import {getChildrenToRender} from '../../utils';
import "./header.less";

const {Item, SubMenu} = Menu;

class Header extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            phoneOpen: undefined,
            currentKey: ""
        };
    }

    phoneClick = () => {
        const phoneOpen = !this.state.phoneOpen;
        this.setState({
            phoneOpen,
        });
    };
    handleClick = ({item, key}) => {
        this.setState({
            currentKey: key
        })
    }

    toEn() {
        location.href = "http://en.metridynamic.com/";
    }

    render() {
        const {dataSource, isMobile, ...props} = this.props;
        const {phoneOpen} = this.state;
        const navData = dataSource.Menu.children;//菜单集合
        const navChildren = navData.map((item) => {
            const {children: a, subItem, ...itemProps} = item;
            if (subItem) {
                return (
                    <Menu.SubMenu
                        key={item.name}
                        {...itemProps}
                        title={
                            <div
                                {...a}
                                className={`header0-item-block ${a.className}`.trim()}
                            >
                                <div>{a.children.map(getChildrenToRender)}</div>
                            </div>
                        }
                        popupClassName="header0-item-child"
                    >
                        {subItem.map(($item, ii) => {
                            const {children: b, subItem, ...itemProps} = $item;
                            console.log(subItem)
                            if (subItem) {//有二级菜单
                                return (
                                    <Menu.SubMenu
                                        key={subItem.name}
                                        {...itemProps}
                                        title={
                                            <div
                                                {...b}
                                                className={`header0-item-block ${b.className}`.trim()}
                                            >
                                                {b.children.map(getChildrenToRender)}
                                            </div>
                                        }
                                        popupClassName="header0-item-child"
                                    >
                                        {subItem.map(($item, ii) => {
                                            const {children: c, subItem, ...itemProps} = $item;
                                            const child = c.href ? (
                                                <Link {...c}>
                                                    {c.children.map(getChildrenToRender)}
                                                </Link>
                                            ) : (
                                                <div {...c}>
                                                    {c.children.map(getChildrenToRender)}
                                                </div>
                                            );
                                            return (
                                                <Menu.Item key={$item.name || ii.toString()} {...$item}>
                                                    {child}
                                                </Menu.Item>
                                            );
                                        })}
                                    </Menu.SubMenu>
                                );
                            } else {
                                const child = b.href ? (
                                    <Link {...b}>
                                        {b.children.map(getChildrenToRender)}
                                    </Link>
                                ) : (
                                    <div {...b}>
                                        {b.children.map(getChildrenToRender)}
                                    </div>
                                );
                                return (
                                    <Menu.Item key={$item.name || ii.toString()} {...$item}>
                                        {child}
                                    </Menu.Item>
                                );
                            }
                        })}
                    </Menu.SubMenu>
                );
            }
            return (
                <Item key={item.name} {...itemProps}>
                    <a {...a} className={`header0-item-block ${a.className}`.trim()}>
                        {/*<NavLink to={item.children.href}>*/}
                        {a.children.map(getChildrenToRender)}
                        {/*</NavLink>*/}
                    </a>
                </Item>
            );
        });
        const moment = phoneOpen === undefined ? 300 : null;
        return (
            <TweenOne
                component="header"
                animation={{opacity: 0, type: 'from'}}
                {...dataSource.wrapper}
                {...props}
            >
                {isMobile && (<a href="/contact" class="header0-item-block getaquote"><div name="text">获取报价</div></a>)}
                <div
                    {...dataSource.page}
                    className={`${dataSource.page.className}${phoneOpen ? ' open' : ''}`}

                >

                    {isMobile && (<Image className='en' onClick={this.toEn} preview={false} src="https://qiniu.metridynamic.com/image/20220623-172348.png" />)}
                    <TweenOne
                        animation={{x: -30, type: 'from', ease: 'easeOutQuad'}}
                        {...dataSource.logo}
                    >
                        <img width="100%" src={dataSource.logo.children} alt="img"/>
                    </TweenOne>
                    {isMobile && (
                        <div
                            {...dataSource.mobileMenu}
                            onClick={() => {
                                this.phoneClick();
                            }}
                        >
                            <em/>
                            <em/>
                            <em/>
                        </div>
                    )}
                    <TweenOne
                        animation={{x: -30, type: 'from', ease: 'easeOutQuad'}}
                        className='online-demo'
                    >
                    </TweenOne>
                    <TweenOne
                        {...dataSource.Menu}
                        animation={
                            isMobile
                                ? {
                                    height: 0,
                                    duration: 300,
                                    onComplete: (e) => {
                                        if (this.state.phoneOpen) {
                                            e.target.style.height = 'auto';
                                        }
                                    },
                                    ease: 'easeInOutQuad',
                                }
                                : null
                        }
                        moment={moment}
                        reverse={!!phoneOpen}
                    >
                        <a href="/contact" class="header0-item-block getaquote"><div name="text">获取报价</div></a>
                        <Menu
                            mode={isMobile ? 'inline' : 'horizontal'}
                            onClick={this.handleClick}
                            selectedKeys={this.state.currentKey}
                            triggerSubMenuAction='hover'
                        >
                            {navChildren}
                        </Menu>
                        {!isMobile && (<Image className='en' onClick={this.toEn} preview={false} src="https://qiniu.metridynamic.com/image/20220623-172348.png" />)}
                    </TweenOne>
                </div>
            </TweenOne>
        );
    }
}

export default Header;
